mutation ConfirmMultipleMaterialUploads($input: ConfirmMultipleMaterialUploadsInput!) {
  confirmMultipleMaterialUploads(input: $input) {
    success
    materials {
      id
      url
      displayName
      assetType
      topicId
      topicName
      imageSource
    }
    errors {
      file
      error
    }
  }
}
